import { render, staticRenderFns } from "./pwa_shipment_settings.vue?vue&type=template&id=a6e1be88&scoped=true&"
import script from "./pwa_shipment_settings.vue?vue&type=script&lang=js&"
export * from "./pwa_shipment_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e1be88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e1be88')) {
      api.createRecord('a6e1be88', component.options)
    } else {
      api.reload('a6e1be88', component.options)
    }
    module.hot.accept("./pwa_shipment_settings.vue?vue&type=template&id=a6e1be88&scoped=true&", function () {
      api.rerender('a6e1be88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/location/tabs/shipment/pwa_shipment_settings.vue"
export default component.exports